import { cn } from "@/lib/utils";

interface FormCardProps {
  title?: string;
  subtitle?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
  sticky?: boolean;
}

export default function FormCard({
  title,
  subtitle,
  description,
  children,
  className,
  sticky = false,
}: FormCardProps) {
  return (
    <div
      className={cn(
        "bg-white p-6 rounded-lg shadow-lg border border-primary/10 hover:shadow-xl hover:border-primary/20 transition-all duration-300 hover:-translate-y-1",
        sticky && "sticky top-24",
        className
      )}
    >
      {(title || subtitle || description) && (
        <div className="text-center mb-6">
          {title && (
            <h3 className="text-xl font-semibold mb-2 text-foreground">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="text-sm text-muted-foreground">{subtitle}</p>
          )}
          {description && (
            <p className="text-sm text-muted-foreground mt-1">{description}</p>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
